export const debounce = <F extends (...args: Parameters<F>) => ReturnType<F>>(
  func: F,
  waitFor: number, // ms
) => {
  let timeoutId: NodeJS.Timeout;

  const debounced = (...args: Parameters<F>): void => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), waitFor);
  };

  return debounced;
};
